module.exports = __webpack_public_path__ + "static/diy_recipe_wishmas_flower_thumbnail-4d499a9800ee2a5c6db333f8e0464c16.jpg";